import React from 'react'

const SmsPortalIframe = () => {
  return (
    <div style={{ height: '100vh' }}>
    <iframe
      src="https://sms.codewave.co.ke"
      title="SMS Portal"
      style={{ width: '100%', height: '100%', border: 'none' }}
    />
  </div>
  )
}

export default SmsPortalIframe
